import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "matching-list-desktop__wrapper" }
const _hoisted_2 = { class: "matching-list-desktop__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_MatchingListCards = _resolveComponent("MatchingListCards")!
  const _component_ElTabPane = _resolveComponent("ElTabPane")!
  const _component_ElTabs = _resolveComponent("ElTabs")!
  const _component_ListManagementBar = _resolveComponent("ListManagementBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ElTabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        type: "card",
        onTabClick: _ctx.clickTabHandler
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ElTabPane, {
            lazy: true,
            name: _ctx.EMatchingListTabs.DISCOVER
          }, {
            label: _withCtx(() => [
              _createVNode(_component_PxIcon, {
                name: _ctx.matchingTabs.discover.icon,
                class: "px-matching-interest__ctaIcon",
                size: "16"
              }, null, 8, ["name"]),
              _createTextVNode(" " + _toDisplayString(_ctx.matchingTabs.discover.label), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_MatchingListCards)
            ]),
            _: 1
          }, 8, ["name"])
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"])
    ]),
    (_ctx.$screen.lgUp)
      ? (_openBlock(), _createBlock(_component_ListManagementBar, {
          key: 0,
          "available-items": _ctx.listManagementItems,
          onFooterVisibilityChanged: _ctx.onFooterVisibilityChanged
        }, null, 8, ["available-items", "onFooterVisibilityChanged"]))
      : _createCommentVNode("", true)
  ]))
}